<template>
  <div class="page container">
    <div class="container">
      <div class="column">
        <div class="content" v-if='curso && !loading' >
          <h3><u>Você está inscrito no curso:</u></h3>
          <div style="text-align:center">
            <img v-if='curso.imagem_original' :src='`http://localhost:4851/${curso.imagem_thumb}`' />
          </div>
          <h4>{{curso.titulo}}</h4>
          <div v-html='curso.resumido'></div>
          <br />
          <h4>Inscrições:</h4>
          <p> <b> de </b> {{formatInscricao(curso.inscricoes_inicio)}} <b> a </b> {{formatInscricao(curso.inscricoes_fim)}}  </p>
          <br />
          <h4>Local:</h4>
          <p>{{curso.local}}</p>
          <br />
          <div class="notification is-danger" v-if='!detalhes.pago_em'>
            No entanto o pagamento de sua inscrição está pendente.
            Segue abaixo as opções de pagamento para que você fique devidamente inscrito.
          </div>
          <div class="notification is-warning" v-if='detalhes.pendente_em && detalhes.pago_em' >
            Você realizou o pagamento em {{formatInscricao(detalhes.pendente_em)}}, mas estamos aguardando a efetivação do seu cadastro. Se este processo estiver demorando mais que 24h, pedimos que entre em <el-button type="text" @click="$router.push('/p/contato')">contato </el-button> conosco
          </div>
          <div class="notification is-success" v-if='detalhes.pago_em'>
            Vocế já está devidamente inscrito neste curso. Realizou o pagamento em {{formatInscricao(detalhes.pendente_em)}} e o pagamento foi aprovado em {{formatInscricao(detalhes.pago_em)}}
          </div>
          <div v-if='curso.planos.length'>
            <h4>Investimento:</h4>
            <el-select v-model='inscricao' placeholder="Selecionar" @change='selectPayment'>
              <el-option
                v-for="item in curso.planos"
                :key="item.id"
                :label="`${item.titulo} - R$ ${item.valor}`"
                :value="item.id"
                :disabled="item.disabled"
                
                >
              </el-option>
            </el-select>
            <div v-if='codigoLoading'>
              <i class="fa fa-spinner fa-spin"></i> Aguarde, gerando links de pagamento.
            </div>
            <!-- INICIO FORMULARIO BOTAO PAGSEGURO -->
              <form action="https://pagseguro.uol.com.br/checkout/v2/payment.html" method="post" onsubmit="PagSeguroLightbox(this); return false;" v-if='codigo'>
              <!-- NÃO EDITE OS COMANDOS DAS LINHAS ABAIXO -->
                <input type="hidden" name="code" :value="codigo" />
                <input type="hidden" name="iot" value="button" />
                <input type="image" src="https://stc.pagseguro.uol.com.br/public/img/botoes/pagamentos/209x48-comprar-assina.gif" name="submit" alt="Pague com PagSeguro - é rápido, grátis e seguro!" />
              </form>
              <div v-if='codigo'>
                <p>Você pode pagar através de depósito bancário, se preferir.</p>

                <p><b>Alba Lúcia Martins Bastos Dezan</b></p>
                <p><b>CPF: 657 697 241-53</b></p>
                <p><b>Banco do Brasil</b></p>
                <p><b>Agência:</b> 3413-4</p>
                <p><b>Conta:</b> 37459-8</p>
              </div>

              <el-upload
                v-if='codigo'
                class="avatar-uploader"
                :action="`https://espacowinnicottbsb.com.br/api/usuario/curso/${detalhes.id}/upload-comprovante`"
                :headers='{"authorization": `Bearer ${$store.state.session.jwt}`}'
                :show-file-list="false"
                :data='{"plano_id": inscricao}'
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="detalhes.comprovante" :src='image_path(detalhes)' class="avatar">
                <i v-if="detalhes.comprovante" >*clique para mudar a imagem</i>
                <i v-if="!detalhes.comprovante" >*clique para enviar a imagem do comprovante de pagamento</i>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>

            <!-- FINAL FORMULARIO BOTAO PAGSEGURO -->
          
        </div>
        <div v-if='loading' class="is-size-5">
          Aguarde... Estamos carregando as informações do curso
        </div>
        <div v-if='!curso && !loading' class="is-size-5">
          Não foi possível encontrar o curso que você procura
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'

export default {
  name: 'QuemSomos',
  data(){
    return {
      inscricao: null,
      curso: null,
      loading: false,
      detalhes: null,
      codigo: null,
      codigoLoading: false
    }
  },
  methods:{
     image_path(c){
        if(c.comprovante)
          return `https://espacowinnicottbsb.com.br/${c.comprovante}`
        return false
      },
     handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.detalhes.comprovante = res;
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 8;

        if (!isJPG && !isPNG) {
          this.$message.error('As imagems devem ser JPG ou PNG');
        }
        if (!isLt2M) {
          this.$message.error('Imagem não pode exceder 8MB!');
        }
        return (isJPG && isLt2M) || (isPNG && isLt2M);
      },
    selectPayment(p){
      this.getCodigo(p);
    },
    handleClick() {
        console.log('click');
    },
    getCurso(){
      this.loading = true;
      axios.get(`${global.base}/api/usuario/curso/${this.$router.currentRoute.params.id}/visualizar`,{
        headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
        }).then((r)=>{
          this.curso = r.data.curso;
          this.detalhes = r.data.detalhes;
          this.loading = false;
        }).catch(()=>{
          this.curso = null;
          this.loading = false;
        })
    },
    getCodigo(p){
      this.codigo = null;
      this.codigoLoading = true;
      axios.get(`${global.base}/api/usuario/curso/${this.$router.currentRoute.params.id}/${p}/codigo`,{
        headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
        }).then((r)=>{
          this.codigo = r.data.codigo;
          this.codigoLoading = false;
        }).catch(()=>{
          this.codigo = null;
          this.codigoLoading = false;
        })
    },
    formatInscricao(f){
      return moment(f, "%Y-%MM-%DD").format("DD [de] MMMM [de] YYYY");
    }
  },
  mounted(){
    this.getCurso();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .container{
    max-width: 800px;
  }
</style>
